import { LayoutServiceData } from '@sitecore-jss/sitecore-jss-nextjs';
import { affiliateService } from 'lib/affiliate/get-affiliateId';
import { SitecoreIds } from 'lib/constants/sitecore-ids';
import { Condition } from 'lib/rules/types';
import { GetStaticPropsContext } from 'next';
import { Plugin } from '..';

class SpecificAffiliatePlugin implements Plugin {
  conditionId =
    SitecoreIds.Settings.Rules.Definitions.Elements.RbA_Reviews.SpecificAffiliate.ItemId;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async exec(condition: Condition, _context: GetStaticPropsContext, _layout: LayoutServiceData) {
    if ('affiliateItemId' in condition) {
      //@ts-ignore allow for extra condition properties
      const affiliateId = await affiliateService.getAffiliateId(condition.affiliateItemId);
      //@ts-ignore allow for extra condition properties
      condition.affiliateItemId = affiliateId;
    }

    return condition;
  }
}

export const specificAffiliatePlugin = new SpecificAffiliatePlugin();
